import React from "react";
import cx from "classnames";
import { PencilIcon } from "assets";
import ProfileButton from "pages/Profile/components/common/ProfileButton";

interface Props {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
}

const EditButton = ({ onClick, className, iconClassName }: Props) => {
  return (
    <ProfileButton
      onClick={onClick}
      className={cx("h-8 w-8 min-w-8 rounded-full", className)}
    >
      <PencilIcon width={16} height={16} className={iconClassName} />
    </ProfileButton>
  );
};

export default EditButton;
